import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

Turbo.StreamActions.redirect = function() {
  const url = this.getAttribute("url") || this.getAttribute("target")
  if (url) {
    Turbo.visit(url, { action: "advance" })
  }
}

function initAll() {
  // Header dropdown uses Stimulus (dropdown controller)
}

// Run on initial page load
document.addEventListener("DOMContentLoaded", initAll);

// Run after Turbo navigations
document.addEventListener("turbo:load", initAll);
document.addEventListener("turbo:render", initAll);